<template>
  <div class="goto-block">
    <h3 class="goto-block__title">{{ $t('view.flow.block.goto.title') }}</h3>
    <in
      :label="$t('view.flow.block.goto.label')"
      v-model="val.label"
      @input="onInput"
    ></in>
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created() {
    this.val = this.value
  },
  methods: {
    onInput() {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.goto-block {
  @include flowElementShadow();
  width: 35%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__separator {
    margin-top: 20px;
  }

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }
}
</style>
